<template>
  <a-layout>
    <Header />
  </a-layout>
  <a-layout class="con-layout-wrap">
    <a-layout-header>
      <a-col flex="20px">
        <div class="con-logo">
          <AppstoreAddOutlined
            :style="{ fontSize: '24px', color: 'rgb(255, 127, 0)' }"
          />
          <span class="logo-text">{{ siteTitle }}</span>
        </div>
      </a-col>
    </a-layout-header>
    <a-layout
      style="background: #fff; padding-left: 10px"
      class="con-layout-wrap-main"
    >
      <a-layout-sider class="con-header" style="background: #fff; padding: 0px">
        <a-row type="flex">
          <a-col flex="auto">
            <a-menu
              class="con-menu"
              v-model:openKeys="openKeys"
              mode="inline"
              :inlineCollapsed="false"
              v-model:selectedKeys="selectedKeys"
              @select="selectSider"
            >
              <a-menu-item key="/index">
                <span>首页</span>
              </a-menu-item>
              <a-sub-menu key="/contract">
                <template #title>协议管理</template>
                <a-menu-item key="/lygame">联运游戏</a-menu-item>
                <a-menu-item key="/newlygame">新联运游戏</a-menu-item>
                <a-menu-item v-if="hasUnionPackageGame" key="/unifiedpackagegame">统一包游戏</a-menu-item>
                <a-menu-item key="/lyapp">联运应用</a-menu-item>
                <a-menu-item key="/mimoContract">米盟开放平台</a-menu-item>
              </a-sub-menu>
              <a-sub-menu key="/user">
                <template #title>账户信息</template>
                <a-menu-item key="/userinfo">联运账户信息</a-menu-item>
                <a-menu-item key="/mimouserinfo">米盟账户信息</a-menu-item>
              </a-sub-menu>
              <a-menu-item key="/question">
                <span>疑问解答</span>
              </a-menu-item>
            </a-menu>
          </a-col>
        </a-row>
      </a-layout-sider>

      <a-layout-content class="con-content">
        <div>
          <router-view />
        </div>
      </a-layout-content>
    </a-layout>
  </a-layout>
  <a-layout>
    <Footer />
  </a-layout>
</template>
<script>
import { AppstoreAddOutlined } from "@ant-design/icons-vue";
import Header from "@/views/Header.vue";
import Footer from "@/views/Footer.vue";

const webSiteTitle = "合同管理";

export default {
  inject: ["reload"],
  data() {
    return {
      siteTitle: webSiteTitle,
      selectedKeys: [""],
      openKeys: [""]
    };
  },
  components: {
    AppstoreAddOutlined,
    Header,
    Footer
  },
  created: function() {
    const path = this.$router.currentRoute.value.path;
    this.selectedKeys = [path];
    this.openMenu(path);
  },
  computed: {
    siders() {
      return this.$store.state.routes;
    },
    hasUnionPackageGame () {
      return this.$store.state.hasUnionPackageGame
    }
  },
  watch: {
    $router: {
      handler(val) {
        const path = val.currentRoute.value.path;
        this.selectedKeys = [path];
        this.openMenu(path);
      },
      deep: true
    }
  },
  methods: {
    selectSider() {
      console.log(this.selectedKeys);
      this.$router.push(this.selectedKeys[0]);
    },
    openMenu(path) {
      if (path.indexOf("/unifiedpackagecontractlist") === 0) {
        this.openKeys = ["/contract"];
        this.selectedKeys = ["/unifiedpackagegame"];
        return;
      }
      const list1 = ["/index"];
      const list2 = ["/lygame", "/newlygame", "/unifiedpackagegame", "/lyapp", "/mimoContract"];
      const list3 = ["/userinfo", "/mimouserinfo"];
      const list4 = ["/question"];
      if (list1.includes(path)) {
        this.openKeys = ["/index"];
      }
      if (list2.includes(path)) {
        this.openKeys = ["/contract"];
      }
      if (list3.includes(path)) {
        this.openKeys = ["/user"];
      }
      if (list4.includes(path)) {
        this.openKeys = ["/question"];
      }
    }
  }
};
</script>

<style lang="scss">
.con-layout-wrap {
  // display: flex;
  background: #fff;
}
#components-layout-demo-basic .ant-layout-sider {
  background: #fff;
}
.con-layout-wrap header {
  background: #fff;
  height: 80px;
  line-height: 80px;
  padding: 0 50px;
}
.con-layout-wrap-main {
  display: flex;
}
.con-layout-wrap .ant-layout-content {
  background: #fff;
  padding-left: 30px;
  padding-right: 100px;
}
.con-content {
  margin: auto;
  max-width: 1500px;
  min-width: 1200px;
  background: #fff;
  padding-left: 30px;
  padding-right: 100px;
  overflow-x: hidden;
}
.con-layout-wrap .ant-menu {
  padding-top: 9px;
}
.logo-text {
  font-size: 24px;
  color: rgb(255, 127, 0);
}
</style>
